module.exports = __webpack_public_path__ + "img/1505748072.79eb9ed3.jpg";